module.exports = __webpack_public_path__ + "img/sc.0e7b2368.png";